import { render, staticRenderFns } from "./invoice-dashboard-card.vue?vue&type=template&id=6876435c&scoped=true&"
import script from "./invoice-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./invoice-dashboard-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876435c",
  null
  
)

export default component.exports